import React from 'react';
import { StyledTestButton, StyledSaveButton, StyledRemoveButton, StyledStandardButton } from '../../styles/devices/Buttons';


// -------COMMON--------------------------------------------------------------------
export const SaveButton = ({disabled, onClick, text, margin}: {disabled?: boolean; onClick?: any; text?:string; margin?: string}) => {  
    return (
      <StyledSaveButton disabled={disabled} onClick={onClick} margin={margin}>{text}</StyledSaveButton>
    )
}

export const RemoveButton = ({disabled, onClick, text}: {disabled?: boolean; onClick?: any; text?:string}) => {  
    return (
      <StyledRemoveButton disabled={disabled} onClick={onClick}>{text}</StyledRemoveButton>
    )
}

export const StandardButton = ({disabled, onClick, text, background}: {disabled?: boolean; onClick?: any; text?:string; background?: string}) => {  
  return (
    <StyledStandardButton disabled={disabled} onClick={onClick} background={background}>{text}</StyledStandardButton>
  )
}

// -------CAPABILITIES--------------------------------------------------------------
export const TestButton = ({text, onClick}: {text: string; onClick?: any}) => {
  
    return (
      <StyledTestButton onClick={onClick}>{text}</StyledTestButton>
    )
  
}
